export enum StorageKeys {
  AUTH_TOKEN = 'auth-token',
  LOCALE_KEY = 'lang',
  REVIEWED_APPLICATION = 'reviewed-application',
  DEVICE_ID = 'device-id',
  ACCOUNT_LOCKED = 'account-locked',
}

export function getItemFromStorage<T>(key: StorageKeys): T | null {
  try {
    const jsonString = localStorage.getItem(key);
    if (!jsonString) {
      return null;
    }
    return JSON.parse(jsonString);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.debug(
      'Error calling getItem on localStorage.',
      e instanceof ReferenceError ? e.message : e
    );
    return null;
  }
}

export const removeItemFromStorage = (key: StorageKeys): void => {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.debug(
      'Error calling removeItem on localStorage.',
      e instanceof ReferenceError ? e.message : e
    );
  }
};

export const setItemInStorage = <T>(key: StorageKeys, value: T): void => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.debug(
      'Error calling setItem on localStorage.',
      e instanceof ReferenceError ? e.message : e
    );
  }
};
